













































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisStore from '@/components/Suporte/Store/SuporteHospitaisStore'

@Component
export default class ModalRemuneracaoSuporteEditarHospital extends Vue {
  $refs!: {
    formEditarHospital: any,
    imageUpload: any,
  }

  formEditarHospitalRules: any = {
    valid: true,
    hisTipo: [(v: any) => !!v || 'Campo obrigatório'],
  }

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }

  loadSaveOrUpdateHospital: boolean = false
  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get showModalEditarHospital() { return this.getSuporteHospitaisStore.modal.editarHospital }
  set showModalEditarHospital(value: boolean) { this.getSuporteHospitaisStore.setModal({ name: 'editarHospital', value }) }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true

    if (this.$refs.formEditarHospital.validate()) {
      const response = await this.getSuporteHospitaisStore.updateConfiguracaoHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Hospital alterado com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        await this.getSuporteHospitaisStore.getHospitalAll()
        this.showModalEditarHospital = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar o hospital ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateHospital = false
  }

  @Watch('showModalEditarHospital')
  onChangeShowModalEditarHospital(value: boolean) {
    if (!value) {
      this.getSuporteHospitaisStore.clearHospitalConfigFlag()
      this.$refs.formEditarHospital.resetValidation()
      this.$refs.formEditarHospital.reset()
      this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
    }
  }
}
